<template>
    <div class="welcomePanel">
        <img class="logo" src="/img/brand/A-NULL_Icon_korall-rgb.svg"/>
        <div class="text" :class="{withClock}">
            Willkommen bei A-NULL.<br/>
            Schön, dass du da bist.
        </div>
        <div v-if="withClock" class="clockArea">
            <Clock :time="time" size="640"/>
        </div>
    </div>
</template>

<script>
import Clock from './Clock.vue';

export default {
    name: 'WelcomePanel',
    components: {Clock},
    props: {
        withClock: {type: Boolean, default: false},
        time: {type: Date},
    },
}
</script>

<style scoped>
.welcomePanel {
    height: 100%;
    background: #f5f5f5;
    position: relative;
    box-sizing: border-box;
}

.logo {
    position: absolute;
    top: 89px;
    left: 103px;
    width: 540px;
}

.text {
    position: absolute;
    left: 178px;
    top: 620px;
    font-family: FamiljenGrotesk;
    font-weight: 500;
    font-size: 115px;
    line-height: 1.35;
    color: #ff4747;
}

.text.withClock {
    left: 62px;
    top: 690px;
    font-size: 83px;
}

.clockArea {
    position: absolute;
    top: 130px;
    left: 50%;
    width: 50%;
    display: flex;
    justify-content: center;
}
</style>
